import {makeAutoObservable, runInAction} from 'mobx';

import makeQuery from '../../../../api/makeQuery';
import GlobalEvents from '../../../../singletons/GlobalEvents';
import mergeMobxListsBy from '../../../../util/mergeMobxListsBy';
import Log from './Log';

class Logs {
  logMap = new Map();
  list = [];

  constructor(post, initialValues) {
    this.post = post;

    if (initialValues?.length) {
      for (const v of initialValues) {
        const newLog = new Log(this, v);
        this.list.push(newLog);
        this.logMap.set(v.id, newLog);
      }
    }

    makeAutoObservable(this, {
      destroy: false,
      map: false,
    });
  }

  map(cb) {
    return this.list.map(cb);
  }

  replace(arr) {
    mergeMobxListsBy(
      this.logMap,
      this.list,
      arr || [],
      'id',
      (v) => new Log(this, v),
    );
  }

  destroy() {
    this.list.forEach((rx) => rx.destroy());
  }

  getById(id) {
    return this.logMap.map.get(id);
  }

  get length() {
    return this.list.length;
  }

  async addEntry({from, userId, body}) {
    try {
      const { post } = this;
      const entry = { from, userId, body };
      const response = await makeQuery('@postEntry', {
        postId: post.id,
        entry,
      });

      post.merge(response);
    } catch (e) {
      if (e === -1) {
        GlobalEvents.emit('addEntry', {
          status: 'error',
          name: 'Log Entry'
        });
      } else throw e;
    }
  }

  async updateEntry({ entryId, body }) {
    const res = await makeQuery('@putEntry', {
      postId: this.post.id,
      entryId,
      body,
    });
    this.post?.merge?.(res);
    return true;
  }


  async removeEntry(entryId) {
    const idx = this.list.findIndex((log) => log.id === entryId);
    if (idx > -1) {
      const entry = this.list[idx];
      if (entry?.canUserRemove) {
        await entry.remove();
        runInAction(() => {
          entry.destroy();
          this.list.splice(idx, 1);
        });
      } else {
        GlobalEvents.emit('removeEntry', {
          status: 'error',
          name: 'Insufficient permission'
        });
      }
    }
  }


}

export default Logs;
